import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Transition } from 'react-transition-group';
import Scrollbar from 'react-scrollbars-custom';

import ListResponse from './list-response';
import QuestionItem from './question-item';

export const QuestionsList = ({
    questionsData,
    handlers,
    scrollConfig,
    animated = true
}) => {
    const {
        questionsList,
        responseListData,
        responseList,
        currentStep,
        nextUnansweredQuestion,
        talentsNumber
    } = questionsData || {};

    const {
        onPrevQuestion: hanndlePrevQuestion,
        onNextQuestion: hanndleNextQuestion,
        onEditQuestionResponse: hanndleEditQuestionResponse,
        onQuestionResponse: hanndleQuestionResponse,
        onSelectQuestion: selectQuestion,
        onToggleModal: toggleModal
    } = handlers || {};

    const {
        scrollbarRef,
        scrollPosition
    } = scrollConfig || {};

    const animationClasses = {
        appearActive: 'animate__animated animate__slideInRight position-absolute',
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__slideInRight position-absolute',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__slideOutLeft position-absolute',
    };

    const [firstQuestionVisible, setFirstQuestionVisible] = React.useState(false);
    
    // activación de visibilidad de la primera pregunta después de un pequeño delay para que la animación funcione correctamente
    React.useEffect(() => {
        if (currentStep === 1 && animated) {
            setFirstQuestionVisible(false);
            const timer = setTimeout(() => {
                setFirstQuestionVisible(true);
            }, 100);
            return () => clearTimeout(timer);
        } else {
            setFirstQuestionVisible(true);
        }
    }, [currentStep, animated]);

    // Controlar animaciones según currentStep y el prop animated
    const shouldAnimate = animated && currentStep > 0;
    const animationTimeout = shouldAnimate ? { enter: 1000, exit: 1000 } : { enter: 0, exit: 0 };
    const shouldAppear = shouldAnimate;

    // Crear refs para cada pregunta
    const questionRefs = React.useRef({});
    
    const getQuestionRef = (step) => {
        if (!questionRefs.current[step]) {
            questionRefs.current[step] = React.createRef();
        }
        return questionRefs.current[step];
    };

    return (
        <div className='content-questions w-100'>
            <Row className="flex-row-reverse">
                <Col>
                    <div className="rounded border-md question-steps">
                        <div className='d-flex justify-content-between align-items-center mx-lg-3 py-3'>
                            <p className='h5 font-weight-semibold mb-0'>Talents</p>
                            <div className="paginador ml-auto"><p className='h5 font-weight-semibold mb-0'>{talentsNumber}/{questionsList?.items?.size || 0}</p></div>
                            <Button color="outline-primary" size='sm' className='ml-2 p-1 d-lg-none' onClick={toggleModal}>
                                <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 14 14" fill="currentColor">
                                    <path d="M12.5,7c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H7c-0.2,0-0.3-0.1-0.5-0.2C6.4,7.3,6.3,7.2,6.3,7
                              c0-0.2,0.1-0.3,0.2-0.5C6.7,6.4,6.8,6.3,7,6.3h4.8c0.2,0,0.3,0.1,0.5,0.2C12.4,6.7,12.5,6.8,12.5,7z M7,4.2h4.8
                              c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2H7C6.8,2.8,6.7,2.9,6.5,3
                              C6.4,3.2,6.3,3.3,6.3,3.5c0,0.2,0.1,0.3,0.2,0.5C6.7,4.1,6.8,4.2,7,4.2z M11.8,9.8H7c-0.2,0-0.3,0.1-0.5,0.2
                              c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h4.8c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
                              c0-0.2-0.1-0.3-0.2-0.5C12.2,9.9,12,9.8,11.8,9.8z M4.3,2.2L3.1,3.4L2.7,3C2.5,2.9,2.4,2.8,2.2,2.8C2,2.8,1.8,2.9,1.7,3
                              C1.6,3.2,1.5,3.3,1.5,3.5c0,0.2,0.1,0.3,0.2,0.5l0.9,0.9C2.7,4.9,2.7,4.9,2.8,5C2.9,5,3,5,3.1,5C3.2,5,3.2,5,3.3,5
                              c0.1,0,0.2-0.1,0.2-0.1l1.8-1.7C5.4,3,5.5,2.8,5.5,2.6c0-0.2-0.1-0.3-0.2-0.5C5.2,2,5,2,4.8,2C4.6,2,4.5,2,4.3,2.2L4.3,2.2z
                              M4.3,5.7L3.1,6.9L2.7,6.5C2.5,6.4,2.4,6.3,2.2,6.3C2,6.3,1.8,6.4,1.7,6.5C1.6,6.7,1.5,6.8,1.5,7c0,0.2,0.1,0.3,0.2,0.5l0.9,0.9
                              c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1l1.8-1.8c0.1-0.1,0.2-0.3,0.2-0.5
                              c0-0.2-0.1-0.3-0.2-0.5C5.2,5.5,5,5.5,4.8,5.5C4.6,5.5,4.5,5.5,4.3,5.7L4.3,5.7z M4.3,9.2l-1.3,1.3L2.7,10C2.6,10,2.5,9.9,2.4,9.9
                              c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1C1.9,9.9,1.8,10,1.7,10c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3
                              c0,0.1,0.1,0.2,0.1,0.2l0.9,0.9c0.1,0.1,0.1,0.1,0.2,0.1C2.9,12,3,12,3.1,12c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1l1.8-1.8
                              C5.4,10,5.5,9.8,5.5,9.6S5.4,9.3,5.3,9.2C5.2,9,5,9,4.8,9C4.6,9,4.5,9,4.3,9.2L4.3,9.2z"/>
                                </svg>
                            </Button>
                        </div>
                        <div className='lista-question-steps mb-3 d-none d-lg-block'>
                            <Scrollbar style={{ width: '100%', height: '100%' }} thumbsize={60} ref={scrollbarRef}>
                                <ListResponse
                                    list={responseListData}
                                    question={nextUnansweredQuestion?.question}
                                    selectQuestion={selectQuestion}
                                    scrollbarRef={scrollbarRef}
                                    scrollPosition={scrollPosition}
                                />
                            </Scrollbar>
                        </div>
                    </div>
                </Col>
                <Col lg={{ size: 8 }} xs={12} className='overflow-hidden col-question'>
                    {questionsList?.items && questionsList.items.size > 0 && (
                        <div style={{ position: 'relative' }}>
                            {questionsList.items.map((question, index) => {
                                const step = index + 1;
                                const isFirstQuestion = step === 1;
                                const isActive = isFirstQuestion ? (step === currentStep && firstQuestionVisible) : (step === currentStep);
                                const questionRef = getQuestionRef(step);
                                const responseValue = responseList?.get(question.id);
                                
                                return (
                                    <Transition
                                        key={`question-${step}`}
                                        nodeRef={questionRef}
                                        timeout={animationTimeout}
                                        in={isActive}
                                        appear={isActive && shouldAppear}
                                        unmountOnExit={false}
                                    >
                                        {(state) => {
                                            let transitionClasses = '';
                                            if (shouldAnimate) {
                                                if (state === 'entering') {
                                                    transitionClasses = `${animationClasses.enter || ''} ${animationClasses.enterActive || ''}`.trim();
                                                } else if (state === 'entered') {
                                                    transitionClasses = animationClasses.enterActive || '';
                                                } else if (state === 'exiting') {
                                                    transitionClasses = `${animationClasses.exit || ''} ${animationClasses.exitActive || ''}`.trim();
                                                } else if (state === 'exited') {
                                                    transitionClasses = animationClasses.exitActive || '';
                                                }
                                            }
                                            
                                            const isVisible = isActive || state === 'entering' || state === 'exiting';
                                            
                                            return (
                                                <div 
                                                    ref={questionRef} 
                                                    className={`rounded border p-3 question-card w-100 ${transitionClasses} ${isVisible ? 'd-block' : 'none'}`}
                                                    style={{ 
                                                        opacity: (state === 'entering' || state === 'entered') ? 1 : 0,
                                                        pointerEvents: isActive && (state === 'entered' || state === 'entering') ? 'auto' : 'none'
                                                    }}
                                                >
                                                    <div className="nav d-none">
                                                        <button className="btn btn-outline-secondary" onClick={hanndlePrevQuestion} disabled={currentStep <= 1}>{" « Prev "}</button>&nbsp;&nbsp;
                                                        <button className="btn btn-outline-secondary" disabled={currentStep === questionsList?.items?.size} onClick={() => hanndleNextQuestion('questions')}>{" Next » "}</button>
                                                    </div>
                                                    <QuestionItem 
                                                        data={question} 
                                                        hanndleResponse={(responseListData?.length > 0 && step - 1 !== responseListData.length) ? hanndleEditQuestionResponse : hanndleQuestionResponse} 
                                                        select_option={responseValue} 
                                                    />
                                                </div>
                                            );
                                        }}
                                    </Transition>
                                );
                            })}
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    )
}
